<div>
<ng-template #dialerPanel>
  <div
    class="fixed inset-0 sm:static sm:inset-auto flex flex-col overflow-hidden right-10 m-1 dialer-container pointer-events-auto"
    cdkDrag cdkDragBoundary=".cdk-overlay-container" #dragger [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragEnded)="onDragEnd($event)"
    [ngClass]="{
      'minified-container': isZuperConnectMinimized,
      'light-themed': isZuperConnectMinimized ? false : isLightThemed
    }"
    >
    <div class="zuper-connect-container" id="zuper-connect-container"
      *ngIf="integrations['zuperconnect']; else otherDialers"
      [ngClass]="isZuperConnectMinimized ? 'zuper-connect-minify' : ''">
      <div class="zuper-connect-dragger flex justify-between relative w-full px-3 cursor-move"
        *ngIf="!isZuperConnectMinimized">
        <span class="min-h-5 min-w-5 h-5 text-l text-white">Zuper Connect</span>
        <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl cursor-pointer text-white rounded-md zuper-connect-action-icon"
          [svgIcon]="onCall || onCalling ? 'tabler:minimize' : 'tabler:minus'"
          (click)="hideOrMinimizeZuperConnectFrame()"></mat-icon>
      </div>
      <iframe #zuperConnectIframe id="zuper-connect-frame" title="zuper-connect-frame" class="zuper-connect-iframe"
        allow="microphone" [src]="zuperConnectUrl" *ngIf="this.zuperConnectUrl">
      </iframe>
    </div>
  </div>
</ng-template>

<ng-template #otherDialers>
  <div class="other-dialer-container">
    <div class="dialer-dragger flex justify-end relative h-8 w-full px-3 py-1.5 bg-white cursor-move"
      *ngIf="!isZuperConnectMinimized">
      <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl cursor-pointer"
        [svgIcon]="onCall || onCalling ? 'tabler:minimize' : 'tabler:minus'"
        (click)="hideOrMinmizeZuperConnectFrame()"></mat-icon>
    </div>
    <div class="aircall-container" id="aircall-container" *ngIf="integrations[integratedDialerPluginNames.aircall]">
    </div>
    <div class="ring-central-container" id="ring-central-container"
      *ngIf="integrations[integratedDialerPluginNames.ringcentral]">
      <iframe #ringCentralIframe id="ring-central-frame" title="ring-central-frame" class="ring-central-iframe"
        allow="microphone" src="https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/app.html">
      </iframe>
    </div>
  </div>
</ng-template>
</div>